<div class="loader-container">
  <ng-lottie
    [options]="options"/>
  <p>Cargando, por favor espera...</p>
</div>
